// vue
import { useStore } from '@/store';

// hooks
import { useAxios } from '@/vue3/hooks/axiosHook';
import { Project } from '@/vue3/api/models';

export const useProjectService = () => {
    const store = useStore();
    const { apiUrl } = store.state;
    const axios = useAxios();

    const getProjects = async (): Promise<Project[]> => {
        const res = await axios.get(`${apiUrl}/project`);
        return res.data;
    };

    const getProject = async (id: number): Promise<Project> => {
        const res = await axios.get(`${apiUrl}/project/${id}`);
        return res.data;
    };

    const createProject = async (project: any): Promise<Project> => {
        const res = await axios.post(`${apiUrl}/project`, project);
        return res.data;
    };

    const updateProject = async (project: any): Promise<Project> => {
        const res = await axios.put(`${apiUrl}/project`, project);
        return res.data;
    };

    const deleteProject = async (id: number): Promise<any> => {
        const res = await axios.deleteId(`${apiUrl}/project/${id}`);
        return res.data;
    };

    const changeProjectVisibility = async (project: any): Promise<Project> => {
        const payload = {
            id: `${project.id}`,
            name: project.name,
            organizationId: project.organizationId,
            showInBar: project.showInBar,
        };
        const res = await axios.put(`${apiUrl}/project/visibility`, payload);
        return res.data;
    };

    return {
        getProjects,
        getProject,
        createProject,
        updateProject,
        deleteProject,
        changeProjectVisibility,
    };
};
